import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'
import { breakpoint, pxToRem, size } from '@twistopayments/design-system/styles'

const fontSizes = {
  h1: {
    base: pxToRem(36),
    smUp: pxToRem(54),
  },
  h2: {
    base: pxToRem(32),
    smUp: pxToRem(48),
  },
  h3: {
    base: pxToRem(28),
    smUp: pxToRem(38),
  },
}

export const heroTitle = (variant: keyof typeof fontSizes = 'h1') => css`
  line-height: 1.15;
  margin-top: 0;
  margin-bottom: ${size[24]};
  font-size: ${fontSizes[variant].base};

  ${breakpoint.up('sm')} {
    font-size: ${fontSizes[variant].smUp};
    margin-bottom: ${size[32]};
  }
`

export const highlighted = (theme: Theme) => css`
  color: ${theme.palette.secondary.mainContrast};
`
